import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
	imports: [RouterModule],
	selector: 'app-not-found',
	standalone: true,
	styleUrl: './not-found.component.scss',
	templateUrl: './not-found.component.html',
})
export class NotFoundComponent {}
